import {Box, List, Text} from '@mantine/core';
import {ReportSummaryQuestionTypeID} from '../../../../core/entities/reportAnalytics/constants';
import type {
  parseReportSummary,
  summaryContent,
  summaryContentQuestion,
} from '../../../../core/repositories/reportSummaryRepository';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {getAIGradient} from '../../usecase/getAIGradient';

type Props = {
  summaries?: parseReportSummary[];
  reportType?: string;
  hasRecruitments?: boolean;
};

export const OutlineSidebar: React.FC<Props> = ({
  summaries,
  reportType,
  hasRecruitments,
}) => {
  const isSelection = reportType === 'selection';
  const outlineSummaries = summaries?.map((summary) => {
    const isQuestionContent = (
      content: summaryContent | undefined,
    ): content is summaryContentQuestion => {
      return (
        (summary.typeID as ReportSummaryQuestionTypeID) ===
        ReportSummaryQuestionTypeID.QUESTION
      );
    };

    const questionTitle =
      (summary.typeID as ReportSummaryQuestionTypeID) ===
        ReportSummaryQuestionTypeID.QUESTION &&
      isQuestionContent(summary.summary) &&
      summary.summary?.data[0]?.step
        ? `${summary.summary.data[0].step}の面接内容`
        : '面接での質問内容';
    return {
      typeID: summary.typeID,
      typeName:
        (summary.typeID as ReportSummaryQuestionTypeID) ===
          ReportSummaryQuestionTypeID.QUESTION && isSelection
          ? questionTitle
          : summary.typeName,
    };
  });

  return (
    <Box className="w-full bg-white px-12 py-16 mb-16">
      <Box className="w-full flex">
        <Text
          className="text-center text-md font-bold"
          style={{
            background: getAIGradient(),
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          目次
        </Text>
      </Box>
      <List className="list-disc list-inside">
        {outlineSummaries?.map((summary, index) => (
          <CommonLink href={`#summary-type-${index}`} key={`outline-${index}`}>
            <List.Item
              key={`outline-${summary.typeID}`}
              className="text-black-2 text-base hover:text-primary-1"
            >
              {summary.typeName}
            </List.Item>
          </CommonLink>
        ))}
        <CommonLink href="#report-reference">
          <List.Item className="text-black-2 text-base hover:text-primary-1">
            参考にした体験記
          </List.Item>
        </CommonLink>
        {hasRecruitments && (
          <CommonLink href="#recommend-recruitments">
            <List.Item className="text-black-2 text-base hover:text-primary-1">
              この体験記を見ている方におすすめの募集
            </List.Item>
          </CommonLink>
        )}
      </List>
    </Box>
  );
};
